import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  accessDeniedContainer: {
    width: "100%",
    height: "calc(100vh - 64px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "0 20px",
  },
  container: {
    maxWidth: "600px",
  },
  title: {
    marginBottom: "16px",
    color: "#d32f2f",
    fontWeight: 500,
  },
  message: {
    color: "#555",
  },
}));

const AccessDenied = ({
  message = "You do not have access to this page. Please contact your administrator.",
}) => {
  const classes = useStyles();

  return (
    <div className={classes.accessDeniedContainer}>
      <div className={classes.container}>
        <Typography variant="h5" className={classes.title}>
          Access Denied
        </Typography>
        <Typography variant="body1" className={classes.message}>
          {message}
        </Typography>
      </div>
    </div>
  );
};

export default AccessDenied;
